import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin } from "lucide-react";

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="transform:translate(-50%,-100%);font-size:0;line-height:0">
  <svg width="34" height="34" viewBox="0 0 24 24" fill="#ff385c" stroke="white" stroke-width="1.5">
  <path d="M12 22s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12z"/><circle cx="12" cy="10" r="2.6" fill="white" stroke="none"/></svg></div>`,
  iconSize: [0, 0],
});

const Recenter = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position) map.setView(position, Math.max(map.getZoom(), 13));
  }, [map, position]);
  return null;
};

const ClickCapture = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
  return null;
};

export const LocationPicker = ({ value, onChange, height = 260 }) => {
  const [pos, setPos] = useState(value || null);

  useEffect(() => {
    if (value && (!pos || value[0] !== pos[0] || value[1] !== pos[1])) setPos(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value?.[0], value?.[1]]);

  const pick = (p) => {
    setPos(p);
    onChange(p);
  };

  return (
    <div>
      <div className="overflow-hidden rounded-xl border border-border" style={{ height }} data-testid="location-picker-map">
        <MapContainer center={pos || [21.146, 79.088]} zoom={pos ? 13 : 5} scrollWheelZoom className="h-full w-full">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ClickCapture onPick={pick} />
          <Recenter position={pos} />
          {pos && (
            <Marker
              position={pos}
              icon={pinIcon}
              draggable
              eventHandlers={{ dragend: (e) => pick([e.target.getLatLng().lat, e.target.getLatLng().lng]) }}
            />
          )}
        </MapContainer>
      </div>
      <p className="mt-2 flex items-center gap-1.5 text-[11px] text-muted-foreground" data-testid="location-picker-coords">
        <MapPin className="h-3 w-3" />
        {pos ? `Pin at ${pos[0].toFixed(4)}, ${pos[1].toFixed(4)} — drag or tap the map to adjust` : "Enter a city to place the pin"}
      </p>
    </div>
  );
};

export default LocationPicker;
